import {
    CHECK_PAYMENT_LINK_AVAILABLE,
    CREATE_PAYMENT_LINK,
    DELETE_SINGLE_PAYMENT_LINK,
    EDIT_SINGLE_PAYMENT_LINK,
    GET_LINK_TRANSACTIONS,
    GET_PAYMENT_LINK,
    GET_PLAN_LNK,
    GET_SINGLE_PAYMENT_LINK,
    PUBLISH_LINK,
    PUBLISH_LINK_FAILURE,
    PUBLISH_LINK_SUCCESS,
    SET_LINK_TRANSACTIONS,
    SET_PAYMENT_LINK,
    SET_PAYMENT_LINK_AVAILABLE,
    SET_PLAN_LINK,
    SET_SINGLE_PAYMENT_LINK
} from './actionTypes';
export const getPaymentLink = data => {
    return {
        payload: data,
        type: GET_PAYMENT_LINK
    };
};

export const setPaymentLink = data => {
    return {
        payload: data,
        type: SET_PAYMENT_LINK
    };
};

export const createPaymentLink = data => {
    return {
        payload: data,
        type: CREATE_PAYMENT_LINK
    };
};

export const checkPaymentLinkAvail = data => {
    return {
        payload: data,
        type: CHECK_PAYMENT_LINK_AVAILABLE
    };
};

export const setPaymentLinkAvail = data => {
    return {
        payload: data,
        type: SET_PAYMENT_LINK_AVAILABLE
    };
};
export const getSinglePaymentLink = data => {
    return {
        payload: data,
        type: GET_SINGLE_PAYMENT_LINK
    };
};

export const editSinglePaymentLink = data => {
    return {
        payload: data,
        type: EDIT_SINGLE_PAYMENT_LINK
    };
};

export const setSinglePaymentLink = data => {
    return {
        payload: data,
        type: SET_SINGLE_PAYMENT_LINK
    };
};

export const deleteSinglePaymentLink = data => {
    return {
        payload: data,
        type: DELETE_SINGLE_PAYMENT_LINK
    };
};

export const publishToLive = data => {
    return {
        payload: data,
        type: PUBLISH_LINK
    };
};

export const publishToLiveSuccess = data => {
    return {
        type: PUBLISH_LINK_SUCCESS,
        payload: data
    };
};

export const publishToLiveFailure = data => {
    return {
        type: PUBLISH_LINK_FAILURE,
        payload: data
    }
}

export const setPlansForPaymentLink = (data) => {
    return {
        type: SET_PLAN_LINK,
        payload: data
    }
}

export const getPlansForPaymentLink = (data) => {
    return {
        type: GET_PLAN_LNK,
        payload: data
    }
}

export const getLinkTransactions = (data) => {
    return {
        type: GET_LINK_TRANSACTIONS,
        payload: data
    }
}


export const setLinkTransactions = (data) => {
    return {
        type: SET_LINK_TRANSACTIONS,
        payload: data
    }
}